import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40afd862&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=40afd862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afd862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40afd862')) {
      api.createRecord('40afd862', component.options)
    } else {
      api.reload('40afd862', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40afd862&scoped=true&", function () {
      api.rerender('40afd862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/invite/index.vue"
export default component.exports